<script lang="ts">
	import { userHoldingActiveItem } from '../store';
	import UserHistory from './UserHistory.svelte';
	import UserHoldingsMenuItem from './UserHoldingsMenuItem.svelte';
	import UserOrders from './UserOrders.svelte';
	import UserPositions from './UserPositions.svelte';
	import UserOrderHistory from './UserOrderHistory.svelte';
	import DownloadCsv from './DownloadCSV.svelte';
</script>

<div class="border border-fx-grey-500 h-full border-l-0 border-b-0">
	<div class="bg-fx-gradient-7-50 py-2 w-full h-full">
		<div class="flex items-center justify-start gap-3 px-6">
			<div>
				<UserHoldingsMenuItem header="Positions" />
			</div>
			<div>
				<UserHoldingsMenuItem header="Orders" />
			</div>
			<div>
				<UserHoldingsMenuItem header="History" />
			</div>
			<div>
				<UserHoldingsMenuItem header="Order History" />
			</div>
			<div class="grow" />
			<div>
				<DownloadCsv />
			</div>
		</div>

		<div class="border-t border-t-fx-grey-600 my-2" />
		{#if $userHoldingActiveItem == 'positions'}
			<UserPositions showClosePosition={true} />
		{:else if $userHoldingActiveItem == 'orders'}
			<UserOrders />
		{:else if $userHoldingActiveItem == 'order history'}
			<UserOrderHistory />
		{:else}
			<UserHistory />
		{/if}
	</div>
	<div class="flex flex-grow bg-fx-green" />
</div>
